import { render, staticRenderFns } from "./Garantia.vue?vue&type=template&id=bcd3cc92&scoped=true"
import script from "./Garantia.vue?vue&type=script&lang=js"
export * from "./Garantia.vue?vue&type=script&lang=js"
import style0 from "./Garantia.vue?vue&type=style&index=0&id=bcd3cc92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd3cc92",
  null
  
)

export default component.exports